import React, {useEffect, useState} from 'react'
import {useParams} from "react-router-dom";
import styles from "./login/login/login.module.css";
import {PrimaryButton, TextInput} from "../components/input/inputs";
import axiosInstance from "../AxiosInstance";
import inputstyles from '../components/input/inputs.module.css';
import {useTranslation} from "react-i18next";

export default function Register() {
	const {t} = useTranslation();
	const {token } = useParams();
	const [errors, setErrors] = useState([]);
	const [form, setForm] = useState({});
	const [invite, setInvite] = useState({});

	useEffect(() => {
		axiosInstance.get(`user_invite_validate/?token=${token}`).then((response) => {
			setInvite(response.data);
			setForm({
				...form,
				role: response.data.role?.id,
				token: token,
			});
		}).catch((error) => {
			window.location.href = '/login';
		});
	}, []);

	const handleSubmit = (event) => {
		const newErrors = [];

		if (!form.email || !form.username || !form.password || !form.password_again) {
			newErrors.push(t('auth.register.errors.allFieldsRequired'));
		}

		if (form.password && form.password_again && form.password !== form.password_again) {
			newErrors.push(t('auth.register.errors.passwordsDoNotMatch'));
		}

		if (newErrors.length > 0) {
			setErrors(newErrors);
			return;
		}

		setErrors([]);
		axiosInstance.post('users/', form).then((response) => {
			if(response.status === 201) {
				window.location.href = '/login';
			}
		}).catch((error) => {
			const apiErrors = [];
			const data = error.response?.data;

			if (data) {
				if (data.email || data.username) {
					apiErrors.push(t('auth.register.errors.credentialsInvalid'));
				}
				if (data.password) {
					apiErrors.push(t('auth.register.errors.passwordCriteria'));
				}
				if (data.non_field_errors) {
					apiErrors.push(t('auth.register.errors.registrationFailed'));
				}
			}

			if (apiErrors.length === 0) {
				apiErrors.push(t('auth.register.errors.unexpected'));
			}

			setErrors(apiErrors);
		});
	};

	return (
		<div className={styles.container}>

			<div className={styles.background}>
				<img alt={'background'} src={'/login.png'} width={'100%'}/>
			</div>

			<div className={`${styles.loginContainer} px-4 pt-4`}>
				<div className={'pt-4 pb-5'}>
					<img alt={'myindustrialdata'} src={'/mid_purple.png'}/>
					<div></div>
				</div>

				{errors.length > 0 &&
					<div className={`${styles.error} px-3`}>
						<img alt={'alert'} src={'/alert.png'} height={'24px'}/>
						<div>{errors.map((err, i) => <div key={i}>{err}</div>)}</div>
					</div>
				}

				<div className={'mt-3'}>
					<div className={`form-group mb-3`}>
						<input
							disabled={true}
							type={'text'}
							value={`Rol ${invite.role?.name}`}
							className={`${inputstyles.inputBorderDefault} form-control rounded-2`}
							id={`role`}
							style={{color: '#94A3B8'}}
						/>
					</div>
					<TextInput name={'email'} form={form} setForm={setForm} placeholder={t('auth.register.email')} hideName={true}/>
					<TextInput name={'username'} internalName={'username'} form={form} setForm={setForm} placeholder={t('auth.register.username')} hideName={true}/>
					<TextInput name={'password'} internalName={'password'} form={form} setForm={setForm} placeholder={t('auth.register.password')} hideName={true} password={true}/>
					<TextInput name={t('auth.register.repeatPassword')} internalName={'password_again'} form={form} setForm={setForm} placeholder={t('auth.register.repeatPassword')} hideName={true} password={true}/>
				</div>

				{form.password !== form.password_again &&
					<div className={'mb-3'} style={{color: "red"}}>{t('auth.register.errors.passwordsDoNotMatch')}</div>
				}

				<div className={'mb-3'}>
					<PrimaryButton name={t('auth.register.button')} onClick={handleSubmit}/>
				</div>

			</div>
		</div>
	)
}
